/**
 * @file Table feature: resize columns.
 * @since 3.9.0
 */

import TableAbstractFeature from './TableAbstractFeature';

export default class TableResize extends TableAbstractFeature {
  constructor(table) {
    super(table);

    this.x = 0;
    this.w = 0;
    this.column = null;
    this.resizer = null;

    this.listeners = {
      onMouseMove: (evt) => {
        // Determine how far the mouse has been moved
        const dx = evt.clientX - this.x;

        // Update the width of column
        this.column.style.width = `${this.w + dx}px`;
      },
      onMouseUp: () => {
        document.removeEventListener('mousemove', this.listeners.onMouseMove);
        document.removeEventListener('mouseup', this.listeners.onMouseUp);
        this.column = null;
        this.resizer.classList.remove('resizing');
      },
      onMouseDown: (evt) => {
        this.column = evt.target.closest('th');
        this.resizer = evt.target;

        // Get the current mouse position
        this.x = evt.clientX;

        // Calculate the current width of column
        const styles = window.getComputedStyle(this.column);
        this.w = parseInt(styles.width, 10);

        // Attach listeners for document's events
        document.addEventListener('mousemove', this.listeners.onMouseMove);
        document.addEventListener('mouseup', this.listeners.onMouseUp);

        this.resizer.classList.add('resizing');
      }
    };
  }

  /**
   * @public
   */
  init() {
    this._addEventListeners();
  }

  /**
   * @public
   */
  destroy() {
    this._removeEventListeners();
  }

  /**
   * @private
   */
  _addEventListeners() { }

  /**
   * @private
   */
  _removeEventListeners() { }

  /**
   * @private
   */
  _render() {
    this.dom.thead.querySelectorAll('th').forEach((th) => {
      th.style.position = 'relative';
      const resizer = document.createElement('div');
      resizer.classList.add('col-resizer');

      th.appendChild(resizer);

      resizer.addEventListener('mousedown', this.listeners.onMouseDown);
    });
  }


  /**
   * From observer Table.js
   */

  beforeCreatedHead() {
    if (this.dom.thead) {
      this.dom.thead.querySelectorAll('.col-resize').forEach((resizer) => {
        resizer.removeEventListener('mousedown', this.listeners.onMouseDown);
        resizer.remove();
      });
    }
  }

  onCreatedHead() {
    this._render();
  }
}
